const ChatMessageBubble = ({ message }) => {
  const {
    sender,
    text,
    image,
    isTyping,
  } = message

  return (
    <div
      className={`chat-message ${
        sender === 'user' ? 'chat-message-user' : 'chat-message-bot'
      }`}
    >
      {image && (
        <img
          src={image}
          alt=''
          className='chat-message-image'
        />
      )}

      {isTyping ? (
        <div className='typing-indicator'>
          <span />
          <span />
          <span />
        </div>
      ) : (
        text && <span>{text}</span>
      )}
    </div>
  )
}

export default ChatMessageBubble